// src/Presentation/Components/Modals/AddToCartChoiceModal.tsx
import React from "react";
import styles from "./Modals.module.css";
import Close from "Utils/Assets/SVGs/Close";
import LoginIcon from "Utils/Assets/SVGs/LoginIcon";
import UserIcon from "Utils/Assets/SVGs/UserIcon";
import { IAccountModeModalProps } from "@model/AccountModeModal.model";

/**
 * If user is not logged in
 * gives the user a notice to login
 * as well as to continue as guest
 */

const AddToCartChoiceModal: React.FC<IAccountModeModalProps> = ({
  modalVisibility,
  onContinueAsGuest,
  onLogin,
  onClose,
}) => {
  if (!modalVisibility) return null;

  return (
    <div className={styles.modalBackdrop} data-testid="modal-backdrop">
      <div
        className={styles.addmodalContainerAdd}
        data-testid="modal-container"
      >
        <button
          className={styles.modalClose}
          onClick={onClose}
          aria-label="Close"
          data-testid="close-button"
        >
          <Close width={24} height={24} />
        </button>

        <div className={styles.addmodalScroll} data-testid="modal-scroll">
          <h2 className={styles.addmodalTitle} data-testid="modal-title">
            Continue as guest or log in
          </h2>
          <p className={styles.addtext}>
            You can add items as a guest and log in later, or log in now to sync
            your cart across devices.
          </p>
          <div className={styles.addactionsRow}>
            <button
              type="button"
              className={`${styles.addmodalActionBtn} ${styles.addbtnWhite}`}
              onClick={onLogin}
              data-testid="login-btn"
            >
              <span className={styles.addbtnIcon}>
                <LoginIcon width={18} height={18} />
              </span>
              <span>Log in</span>
            </button>

            <button
              type="button"
              className={`${styles.addmodalActionBtn} ${styles.addbtnGreyLight}`}
              onClick={onContinueAsGuest}
              data-testid="guest-btn"
            >
              <span className={styles.addbtnIcon}>
                <UserIcon width={18} height={18} />
              </span>
              <span>Continue as guest</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddToCartChoiceModal;
